<template>
    <div class="xbk_index_wrap">
        <div v-if="!isCloseXbk" class="content fc ac jsb">
            <img
                class="logo"
                src="http://res.dumovie.com/slide/202006/1592892126732.png"
                alt
            />
            <div class="options fc ac">
                <img
                    @click="selectType('delivery')"
                    :src="
                        xbkType == 'delivery'
                            ? 'http://res.dumovie.com/slide/202006/1591864006668.png'
                            : 'http://res.dumovie.com/slide/202006/1591863740687.png'
                    "
                    alt
                />
                <img
                    @click="selectType('voucher')"
                    :src="
                        xbkType == 'voucher'
                            ? 'http://res.dumovie.com/slide/202006/1591864045234.png'
                            : 'http://res.dumovie.com/slide/202006/1591864082183.png'
                    "
                    alt
                />
            </div>
        </div>
        <div v-else class="announcement fc ac">
            <img :src="imgBaseUrl + xbkAnnouncePath" alt="">
        </div>
    </div>
</template>

<script>
import { MessageBox } from "mint-ui";
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            xbkType: "",
            openid: this.getLocal("openid") ? this.getLocal("openid") : "", //微信openid
            code: sessionStorage.getItem("code")
                ? sessionStorage.getItem("code")
                : "", //获取微信openid需要的code
            isCloseXbk: false,
            xbkAnnouncePath: ""
        };
    },
    components: {},
    created() {
        this.getStatus()
        if (this.code && !this.openid) {
            this.getOpenId();
        }
    },
    methods: {
        // 获取是否关闭星巴克功能的状态
        getStatus() {
            this.$post({
                method: "meishi.open.cfg",
            }).then((res) => {
                if (res.success && res.data.length) {
                    for(let i of res.data){
                        if(i.category == "starbucks"){
                            this.isCloseXbk = i.status == "close" ? true : false
                            this.xbkAnnouncePath = i.img
                        }
                    }
                }
            });
        },
        // 获取微信openid
        getOpenId() {
            this.$post({
                method: "weixin.get.openid",
                code: this.code,
            }).then((res) => {
                if (res.success) {
                    this.openid = res.data;
                    this.setLocal("openid", res.data);
                }
            });
        },
        selectType(type) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                const url = encodeURI(
                    domain + "/duwap/static/getCode/getCode.html?usertype=xbk"
                );
                window.location.href = url;
                return;
            }
            this.xbkType = type;
            setTimeout(() => {
                this.enterType(type);
            }, 500);
        },
        enterType(type) {
            switch (type) {
                case "delivery":
                    MessageBox.confirm(
                        "本外卖为第三方提供服务，配送可能会有延迟。一切商业行为与星巴克无关。为了更好的体验，会自动选择距离最近的门店。线上门店信息、地址仅供参考，如有疑问请联系客服。"
                    )
                        .then((action) => {
                            if (action == "confirm") {
                                this.$router.push("/xbkMenu");
                            }
                        })
                        .catch((err) => {
                            this.xbkType = "";
                            console.log(err);
                        });

                    break;
                case "voucher":
                    this.$router.push("/xbkVoucher");
                    break;
            }
        },
    },
};
</script>
<style lang="scss">
.xbk_index_wrap {
    width: 100%;
    .content {
        background: #fff;
        height: 100vh;
        width: 100%;
        .logo {
            width: 318px;
            height: 425px;
            margin-top: 90px;
        }
        .options {
            margin-bottom: 170px;
            img {
                width: 610px;
                height: 160px;
                margin-top: 40px;
            }
        }
    }
    .announcement {
        width: 100%;
        min-height: 100vh;
        background: #fff;
        img {
            width: 100%;
        }
    }
}
.mint-msgbox-wrapper {
    .mint-msgbox {
        font-size: 28px !important;
        border-radius: 10px;
        .mint-msgbox-header {
            padding-top: 30px;
            .mint-msgbox-title {
                font-size: 30px !important;
            }
        }
        .mint-msgbox-content {
            padding: 30px;
        }
        .mint-msgbox-btns {
            height: 90px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/xbk/xbkIndex.vue